import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'
import { Grid, Typography } from '@mui/material'
import { LabraToolTipV2 } from '@labrav/react-components'
import { useStyles } from './SearchRanking.styles'

export const TipsButton = ({ openDrawer }: { openDrawer: () => void }) => {
  const { classes } = useStyles()
  return (
    <Grid
      size={{
        md: 3,
      }}
    >
      <div
        className={classes.tipsClasses}
        data-testid="tips"
        onClick={openDrawer}
      >
        <div className={classes.tipsContentWrapper}>
          <FontAwesomeIcon icon={faLightbulb} />
          <Typography>Tips for ranking improvement</Typography>
        </div>
        <LabraToolTipV2
          tooltipPlacement="top"
          description={'View tips to improve ranking.'}
          tooltipPlacmentGap="0px"
        >
          <FontAwesomeIcon icon={faInfoCircle} className={classes.infoIcon} />
        </LabraToolTipV2>
      </div>
    </Grid>
  )
}
